import React, { useEffect, useState } from "react";
import { Evolucion, Paciente, Turno, Usuario } from "../../interfaces";
import { IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonText, IonRow } from "@ionic/react";
import EvolucionViewer from "../EvolucionViewer/EvolucionViewer";
import dayjs from "dayjs";
import StyledButton from "../StyledButton/StyledButton";
import { searchOutline } from "ionicons/icons";
import { useSession } from "../../hooks/SessionContext";

require("dayjs/locale/es");

interface ContainerProps {
  evolucionTurno?: Evolucion;
}
const TurnoViewer: React.FC<ContainerProps> = ({ evolucionTurno }) => {
  const { turnoSeleccionado } = useSession();
  return (
    <IonCard>
      <IonCardContent>
        <IonGrid>
          <IonRow className="ion-text-start">
            <IonCol className="ion-text-start">
              <IonText>
                Informacion de turno: {dayjs(turnoSeleccionado?.fecha).format("YYYY-MM-DD")}{" "}
                {dayjs(turnoSeleccionado?.hora).format("HH:mm")} hs.
              </IonText>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-start" sizeXs="6" sizeMd="8">
              <IonText>Observacion: {turnoSeleccionado?.observaciones}</IonText>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};

export default TurnoViewer;
